import { render, staticRenderFns } from "./RollTable.vue?vue&type=template&id=cdd76892&lang=pug&"
import script from "./RollTable.vue?vue&type=script&lang=ts&"
export * from "./RollTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports